import React, { useEffect } from "react";
import MessagerieMain from "../components/messagerie/MessagerieMain";
export default function Messagerie() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <MessagerieMain />
    </>
  );
}
